import { Box, BoxProps, ColorOptions, LoaderNew, Spacer, TextNew, TextNewProps } from '@jfs/ui-new'

export const FallbackScreen = () => {
  return (
    <Box {...style.mainViewWrap}>
      <LoaderNew color="BLUE" />
      <Spacer size={12} />
      <TextNew {...style.loadingText}>{'Loading'}</TextNew>
    </Box>
  )
}

const style = {
  mainViewWrap: {
    f: 1,
    h: '100vh',
    backgroundColor: 'WHITE' as ColorOptions,
    justify: 'center',
  } as BoxProps,
  loadingText: {
    type: 'bodyMedium14',
    textAlign: 'center',
    color: 'PRIMARY',
  } as TextNewProps,
}
